<div class="">
    <h2 mat-dialog-title class="text-center"><strong>{{title}}</strong></h2>
    <div mat-dialog-content>
        <app-loan-table [header]="resolutionHeader" [tableData]="resolutionTable"></app-loan-table>
    </div>
  </div>